<template>
    <div class="contents group">
        <div class="builder-type-preview">
            <div v-for="attribute in attributes" :key="attribute.slug" class="level__options">
                <Field
                    v-if="attribute.slug !== 'content'"
                    v-model="modelValue[attribute.slug]"
                    :field="{ ...attribute, showHideBar: true, height: 'h-auto' }"
                    :dusk="`form-content-${levelIndex}-${attribute.slug}`"
                    label-position="none"
                />
                <codemirror
                    v-else
                    ref="codemirrorInstance"
                    v-model="modelValue[attribute.slug]"
                    :style="{ minHeight: '200px' }"
                    :autofocus="true"
                    :indent-with-tab="true"
                    :tab-size="2"
                    :dusk="`form-content-${levelIndex}-${attribute.slug}`"
                    :extensions="extensions"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, toRefs, watchEffect } from 'vue';
import { Codemirror } from 'vue-codemirror';
import { EditorView } from '@codemirror/view';
import { css } from '@codemirror/lang-css';
import { githubLight } from '@src/Common/CodemirrorThemes/GithubLight';
import { githubDark } from '@src/Common/CodemirrorThemes/GithubDark';
import { useColorMode } from '@vueuse/core';

const codemirrorInstance = ref(null);
const extensions = ref([]);

const mode = useColorMode({
    emitAuto: true,
});

const detectSystemColorScheme = () => {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
};

const updateExtensions = () => {
    const currentMode = mode.value === 'auto' ? detectSystemColorScheme() : mode.value;
    extensions.value = [css(), currentMode === 'light' ? githubLight : githubDark, EditorView.lineWrapping];
};

const modelValue = defineModel({
    type: [Object, undefined],
});

interface Props {
    attributes?: any[];
    levelIndex?: number;
}

const props = withDefaults(defineProps<Props>(), {
    attributes: () => [],
    levelIndex: 0,
});

const { attributes, levelIndex } = toRefs(props);

watchEffect(() => {
    updateExtensions();

    if (codemirrorInstance.value?.editor) {
        codemirrorInstance.value.editor.dispatch({
            effects: EditorView.reconfigure.of(extensions.value),
        });
    }
});
</script>
